module.exports = __webpack_public_path__ + "static/media/01. peruri.0184bbc2.png";